import { Lock } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import { grey } from '@mui/material/colors'

export interface RosterAccessIndicatorProps {
    isLocked: boolean
}

const RosterAccessIndicator: React.FC<RosterAccessIndicatorProps> = ({
    isLocked,
}) => {
    return (
        isLocked && (
            <Tooltip title="This search has not been shared with you">
                <Box>
                    <IconButton disabled size="small">
                        <Lock sx={{ color: grey[500] }} />
                    </IconButton>
                </Box>
            </Tooltip>
        )
    )
}

export default RosterAccessIndicator
